export const networkCodes = {
  tokenNotValid: "token_not_valid",
  passwordChanged: "password_changed"
}
